import { render, staticRenderFns } from "./AssignDeviceInformation.vue?vue&type=template&id=d5bb1d20&scoped=true"
import script from "./AssignDeviceInformation.vue?vue&type=script&lang=js"
export * from "./AssignDeviceInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bb1d20",
  null
  
)

export default component.exports